import { Link } from "react-router-dom";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link className="brand" to="/" aria-label="Steria House home">
      <img
        className="brand-logo"
        src="/steriahouse-logo.jpg"
        alt=""
        width="1254"
        height="1254"
        loading="eager"
        decoding="async"
        fetchPriority="high"
        aria-hidden="true"
      />
      {!compact && (
        <span className="brand-name">
          Steria <strong>House</strong>
        </span>
      )}
    </Link>
  );
}
